import algoliasearch from 'algoliasearch/lite';

// Create a client with your Algolia credentials
const searchClient = algoliasearch(
  '0WBW2CLI03',
  '50dbc6913a5b5dc567ffc9671bf740ce'
);

export const fetchChannels =
  (
    searchQuery,
    selectedCategories,
    selectedCountries,
    selectedLanguages,
    page,
    pageSize
  ) =>
  async (dispatch) => {
    const selectedFilters = {
      categories: selectedCategories,
      country: selectedCountries,
      languages: selectedLanguages,
    };
    const filtersQueryString = Object.entries(selectedFilters)
      .map(([attribute, values]) =>
        values.map((value) => `${attribute}:${value.code}`).join(',')
      )
      .join(',');

    const filters = filtersQueryString.split(',').filter((f) => f !== '');

    const categories = filters.filter((f) => f.startsWith('categories'));
    const countries = filters.filter((f) => f.startsWith('country'));
    const languages = filters.filter((f) => f.startsWith('languages'));
    let filtersString = '';

    if (countries.length > 0) {
      filtersString += countries.length > 0 ? `${countries.join(' OR ')}` : '';
    }
    if (categories.length > 0) {
      if (filtersString !== '') {
        filtersString += ' AND ';
      }
      filtersString +=
        categories.length > 0 ? `${categories.join(' OR ')}` : '';
    }
    if (languages.length > 0) {
      if (filtersString !== '') {
        filtersString += ' AND ';
      }
      filtersString += languages.length > 0 ? `${languages.join(' OR ')}` : '';
    }

    dispatch({ type: 'FETCH_CHANNELS_REQUEST' });
    try {
      const index = searchClient.initIndex('channels');
      const searchOptions = {
        filters: filtersString,
        hitsPerPage: pageSize,
        page: page - 1,
      };

      const searchResults = await index.search(searchQuery, searchOptions);
      const channels = searchResults.hits;

      dispatch({
        type: 'FETCH_CHANNELS_SUCCESS',
        payload: {
          channels,
          totalChannels: searchResults.nbHits,
          totalPages: searchResults.nbPages,
        },
      });
    } catch (error) {
      dispatch({
        type: 'FETCH_CHANNELS_FAILURE',
        payload: {
          error: error.message,
        },
      });
    }
  };
